import { api, unwrap } from 'shared/api';
import { userState } from 'shared/user-state';
export function getModels() {
  // TODO this is redundant with the src\shared\common.api.js version
  return api.get(`/companies/${userState.getAsCompanyId()}/fields`).then(unwrap);
}